import Vue from '../../lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '../../lib/utils/vue3compat/vue_apollo.js?vue3';
import { parseBoolean } from '@gitlab/frontend-utils';
import { initVueApp } from '../../lib/utils/vue3compat/init_vue_app.js?vue3';
import PipelineHeader from './header/pipeline_header.vue?vue3';

Vue.use(VueApollo);

export const createPipelineHeaderApp = (elSelector, apolloProvider, graphqlResourceEtag) => {
  const el = document.querySelector(elSelector);

  if (!el) {
    return;
  }

  const {
    fullPath,
    pipelineIid,
    pipelinesPath,
    identityVerificationPath,
    identityVerificationRequired,
    mergeTrainsAvailable,
    canReadMergeTrain,
    mergeTrainsPath,
    mergeRequestPath,
  } = el.dataset;

  initVueApp({
    el,
    name: 'PipelineHeaderApp',
    apolloProvider,
    provide: {
      paths: {
        fullProject: fullPath,
        graphqlResourceEtag,
        pipelinesPath,
        mergeRequestPath: mergeRequestPath ? `${gon.gitlab_url}${mergeRequestPath}` : '',
      },
      pipelineIid,
      identityVerificationPath,
      identityVerificationRequired: parseBoolean(identityVerificationRequired),
      mergeTrainsAvailable: parseBoolean(mergeTrainsAvailable),
      canReadMergeTrain: parseBoolean(canReadMergeTrain),
      mergeTrainsPath,
    },
    component: PipelineHeader,
  });
};
